import { all, fork } from 'redux-saga/effects';
import createSaga from './create/saga';
import viewSaga from './view/saga';

function* currencySaga() {
    yield all([
        fork(createSaga),
        fork(viewSaga),
    ]);
}

export default currencySaga;